module.exports = __webpack_public_path__ + "static/media/fal_fal_roo_lad.e08384f7.png";